import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  EstablishmentTechnicalProfessionalData,
  EstablishmentTechnicalProfessionalResponse,
} from '@/common/types/establishmentTechnicalProfessional'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useEstablishmentTechnicalProfessional: (
  id: string,
) => UseQueryResult<EstablishmentTechnicalProfessionalData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<EstablishmentTechnicalProfessionalResponse, unknown, EstablishmentTechnicalProfessionalData>({
    queryKey: ['establishmentTechnicalProfessional', id],
    queryFn: () => privateAxios.get(`/maintenance/establishment_technical_professionals/${id}`),
    select: (data) => data?.data?.data,
  })
}
